export const EditIcon: React.FC<React.ComponentProps<'svg'>> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1471 3C18.9038 3 18.6629 3.04793 18.438 3.14104C18.2132 3.23416 18.009 3.37064 17.8369 3.5427L4.40789 16.9717L3.42524 20.5748L7.02829 19.5921L20.4573 6.1631C20.6294 5.99104 20.7659 5.78678 20.859 5.56198C20.9521 5.33717 21 5.09623 21 4.8529C21 4.60957 20.9521 4.36863 20.859 4.14383C20.7659 3.91902 20.6294 3.71476 20.4573 3.5427C20.2853 3.37064 20.081 3.23416 19.8562 3.14104C19.6314 3.04793 19.3904 3 19.1471 3ZM17.6727 1.29328C18.1401 1.09966 18.6412 1 19.1471 1C19.6531 1 20.1541 1.09966 20.6216 1.29328C21.089 1.48691 21.5138 1.77071 21.8715 2.12849C22.2293 2.48626 22.5131 2.911 22.7067 3.37846C22.9004 3.84592 23 4.34693 23 4.8529C23 5.35887 22.9004 5.85988 22.7067 6.32734C22.5131 6.7948 22.2293 7.21954 21.8715 7.57731L8.25472 21.1941C8.13167 21.3172 7.97863 21.406 7.81073 21.4518L2.26314 22.9648C1.91693 23.0592 1.54667 22.9609 1.29292 22.7071C1.03917 22.4534 0.940838 22.0831 1.03526 21.7369L2.54824 16.1893C2.59403 16.0214 2.68284 15.8684 2.8059 15.7453L16.4227 2.12849C16.7805 1.77071 17.2052 1.48691 17.6727 1.29328Z"
        fill="currentColor"
      />
    </svg>
  );
};
